module.exports = __webpack_public_path__ + "img/hotel7.31eab015.png";